module.exports = "/_next/static/files/c7e7a6912e64a274983e7a6221ba5b11.jpg";